module.exports = __webpack_public_path__ + "caa664a707088546fbcbafed4bed385c.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/history/4.jpg
// module id = 509
// module chunks = 0